export const mockData = {
  company: {
    name: "Clean Home Peterborough",
    tagline: "Professional Cleaning Services in Peterborough",
    description: "We provide reliable, insured, and DBS-checked home cleaning services for homes and businesses in Peterborough. Let's make your home shine!",
    phone: "+447842860575",
    phoneDisplay: "07842 860575",
    email: "cleanhomepeterborough@gmail.com",
    instagram: "@cleanhome2",
    instagramUrl: "https://www.instagram.com/cleanhome2/",
    whatsapp: "447842860575",
    location: "Peterborough, United Kingdom",
    teamPhoto: "https://customer-assets.emergentagent.com/job_cleanhome-experts/artifacts/rmt18wqf_Screenshot_20251102_180833_Gallery.jpg"
  },
  
  cleaningTypes: [
    { value: "deep", label: "Deep Cleaning" },
    { value: "weekly", label: "Regular Weekly Cleaning" },
    { value: "fortnight", label: "Regular Fortnight Cleaning" },
    { value: "renovation", label: "Post Renovation Cleaning" },
    { value: "tenancy", label: "Before/After Tenancy Cleaning" }
  ],
  
  kitchenAppliances: [
    { id: "oven", label: "Oven cleaning" },
    { id: "extractor", label: "Extractor cleaning" },
    { id: "washing", label: "Washing machine cleaning" },
    { id: "fridge", label: "Fridge cleaning" }
  ],

  services: [
    {
      id: 1,
      title: "Domestic Cleaning",
      description: "Regular home cleaning services tailored to your needs",
      icon: "home"
    },
    {
      id: 2,
      title: "Deep Cleaning",
      description: "Thorough cleaning of every corner of your property",
      icon: "sparkles"
    },
    {
      id: 3,
      title: "Window Cleaning",
      description: "Crystal clear windows inside and out",
      icon: "square"
    },
    {
      id: 4,
      title: "Kitchen & Bathroom",
      description: "Specialized cleaning for kitchens and bathrooms",
      icon: "droplet"
    },
    {
      id: 5,
      title: "Commercial Cleaning",
      description: "Professional cleaning for offices and businesses",
      icon: "building"
    },
    {
      id: 6,
      title: "End of Tenancy",
      description: "Complete cleaning for moving in or out",
      icon: "key"
    },
    {
      id: 7,
      title: "Post-Renovation",
      description: "Clean up after construction or renovation work",
      icon: "hammer"
    },
    {
      id: 8,
      title: "Garden Cleaning",
      description: "Outdoor space cleaning and maintenance",
      icon: "flower"
    },
    {
      id: 9,
      title: "Regular Cleaning",
      description: "Weekly or monthly scheduled cleaning services",
      icon: "calendar"
    }
  ],

  pricing: [
    {
      id: 1,
      service: "Domestic Cleaning",
      price: "£20",
      unit: "per hour",
      description: "Regular home cleaning"
    },
    {
      id: 2,
      service: "Deep Cleaning",
      price: "£25",
      unit: "per hour",
      description: "Intensive deep clean"
    },
    {
      id: 3,
      service: "End of Tenancy",
      price: "From £150",
      unit: "per property",
      description: "Based on property size"
    },
    {
      id: 4,
      service: "Commercial Cleaning",
      price: "£25",
      unit: "per hour",
      description: "Office and business spaces"
    },
    {
      id: 5,
      service: "Window Cleaning",
      price: "From £30",
      unit: "per visit",
      description: "All windows cleaned"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Sarah Mitchell",
      location: "Peterborough",
      rating: 5,
      text: "Very friendly and professional cleaners. My house has never looked better! Highly recommend Clean Home Peterborough."
    },
    {
      id: 2,
      name: "Mark Johnson",
      location: "Peterborough",
      rating: 5,
      text: "Excellent service! They are thorough, reliable and always on time. The team is trustworthy and does an amazing job."
    },
    {
      id: 3,
      name: "Emma Davies",
      location: "Peterborough",
      rating: 5,
      text: "I've been using their services for 6 months now. Always consistent quality and very reasonable prices. Thank you!"
    }
  ],

  faqs: [
    {
      id: 1,
      question: "Do you bring your own supplies?",
      answer: "Yes, we bring eco-friendly cleaning products and all necessary equipment. If you prefer us to use your products, just let us know."
    },
    {
      id: 2,
      question: "Are you insured and DBS checked?",
      answer: "Yes, all our cleaners are fully insured and DBS checked for your peace of mind and security."
    },
    {
      id: 3,
      question: "How do you calculate pricing?",
      answer: "We offer hourly rates or fixed quotes after a short assessment. We always confirm the final price before starting work."
    },
    {
      id: 4,
      question: "What areas do you cover?",
      answer: "We cover Peterborough and nearby areas. Contact us to confirm if we service your location."
    },
    {
      id: 5,
      question: "What is your cancellation policy?",
      answer: "Cancellations are free up to 24 hours before the scheduled visit. Late cancellations may incur a small fee."
    }
  ],

  trustBadges: [
    {
      id: 1,
      title: "Fully Insured",
      description: "Complete insurance coverage",
      icon: "shield-check"
    },
    {
      id: 2,
      title: "DBS Checked",
      description: "All staff verified",
      icon: "user-check"
    },
    {
      id: 3,
      title: "Eco-Friendly",
      description: "Safe cleaning products",
      icon: "leaf"
    },
    {
      id: 4,
      title: "Professional Team",
      description: "Experienced cleaners",
      icon: "users"
    }
  ]
};
